export default "__VITE_ASSET__ecd828ce__"